<template>
  <v-container fluid>
    <v-row>
      <v-col
        v-for="item in sensorData"
        :key="item.did"
        cols="12"
        md="12"
        sm="12"
      >
        <v-card style="min-height: 310px">
          <v-card-text>
            <div>
              <v-row>
                <v-col
                  cols="12"
                  style="text-align: center"
                >
                  <h1>{{ item.did }}</h1>
                </v-col>
                <v-col cols="12">
                  <div
                    class="inner-text"
                    style="
                      width: 144px !important;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                  >
                    <br>
                    <span>機台狀態
                      <span :class="item.statuscolor">
                        {{ item.MachineStatus }}
                      </span>
                    </span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  style="text-align: center"
                >
                  切刀轉速
                </v-col>
                <v-col cols="12">
                  <line-example
                    class="chart"
                    :display="false"
                    :chart="item.linechart"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  style="text-align: center"
                >
                  切刀壽命
                </v-col>
                <v-col cols="12">
                  <bar-chart
                    class="chart"
                    :display="false"
                    :chart="item.barchart"
                    @on-receive="clickbar"
                  />
                </v-col>
              </v-row>
              <v-row class="font20">
                <v-col cols="6">
                  CycleTime
                </v-col>
                <v-col cols="6">
                  {{ item.CycleTime }}
                </v-col>
              </v-row>
              <v-row class="font20">
                <v-col cols="6">
                  wkno
                </v-col>
                <v-col cols="6">
                  {{ item.wkno }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    class="font20"
                    x-large
                    block
                    @click="cuttdone"
                  >
                    完工
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >
          換刀原因說明
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_name1"
                :items="reasonNameList"
                solo
                @input="nameChange1"
              />
            </v-col>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_desc1"
                :items="reasonDescList1"
                label="設備編號"
                solo
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_name2"
                :items="reasonNameList"
                solo
                @input="nameChange2"
              />
            </v-col>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_desc2"
                :items="reasonDescList2"
                label="設備編號"
                solo
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_name3"
                :items="reasonNameList"
                solo
                @input="nameChange3"
              />
            </v-col>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_desc3"
                :items="reasonDescList3"
                label="設備編號"
                solo
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_name4"
                :items="reasonNameList"
                solo
                @input="nameChange4"
              />
            </v-col>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-select
                v-model="reasonObj.reason_desc4"
                :items="reasonDescList4"
                label="設備編號"
                solo
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="6"
              md="6"
              sm="6"
            >
              <v-form ref="form">
                <v-text-field
                  v-model="enterpw"
                  type="password"
                  label="密碼"
                  :rules="errorMessage.chkpwRules"
                  required
                />
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="ch_cutter"
          >
            確認
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ text }}
      <template #action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import LineExample from "./LineChart.js";
import BarChart from "./BarChart.js";
import moment from "moment";
import Cookies from "js-cookie";

export default {
  components: {
    LineExample,
    BarChart,
  },
  data: () => ({
    snackbar: false,
    text: "更新成功",
    showloading: false,
    time: null,
    did: "0",
    pw: "qpwo",
    enterpw: "",
    reasonObj: {
      reason_name1: "",
      reason_desc1: "",
      reason_name2: "",
      reason_desc2: "",
      reason_name3: "",
      reason_desc3: "",
      reason_name4: "",
      reason_desc4: "",
      ip_adrs: "",
      did: "",
      cutter_no: "",
      cg_date: "",
    },
    reasonNameList: [],
    reasonDescList1: [],
    reasonDescList2: [],
    reasonDescList3: [],
    reasonDescList4: [],
    dialog: false,
    kpidataarray: [],
    fieldStatus: "",
    sensorData: [
      { value: 40, text: "a", chart: false },
      { value: 90, text: "b", chart: false },
    ],
    drawer: null,
    chart: {
      labels: ["11:00", "11:05", "11:10"],
      datasets: [
        {
          label: "Data One",
          borderColor: "#FC2525",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "white",
          data: [40, 39, 70],
        },
      ],
    },
    updatetime: "",
    fieldList: ["", "測試用"],
    fieldListValue: "",
    deviceList: ["01"],
    pages: [1, 2, 3, 4],
    startAngle: -110,
    endAngle: 110,
    value: 75,
    separatorStep: 0,
    min: 0,
    max: 100,
    scale: 0,
    innerRadius: 60,
    separatorThickness: 4,
    baseColor: "#d0cdcd",
    easingFct: "Circular",
    easingType: "Out",
    didListValue: "ALL",
    didList: [],
    filterDevice: {},
  }),
  computed: {
    errorMessage() {
      return {
        chkpwRules: [
          (v) => !!v || " is required",
          (v) => v === this.pw || "密碼不符合",
        ],
      };
    },
    easing() {
      const { easingFct, easingType } = this;
      return [easingFct, easingType].join(".");
    },
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  created: function () {
    Cookies.set("url", "/ReportCNC");
    this.updatetime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.init();

    this.time = setInterval(() => {
      this.fieldChange(this.fieldListValue);
    }, 600 * 1000);

    this.did = Cookies.get("did");

    this.fieldListValue = Cookies.get("fieldListValue");

    // console.log("this.did", this.did);
    // console.log("this.fieldListValue", this.fieldListValue);

    let nform = {};

    this.$store
      .dispatch("query_table_v2_cg_cutter_reason", nform)
      .then((res) => {
        // console.log(res);

        for (var i = 0; i < res.length; i++) {
          let name = res[i].reason_name;
          this.reasonNameList.push(name);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  unmounted() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {
    cuttdone() {
      console.log("done");

      this.did = Cookies.get("did");

      let val = Cookies.get("fieldListValue");

      this.filterDevice = this.exec_cust_gateway_000.filter(function (
        item,
        index,
        array
      ) {
        return item.gw_desc == val;
      });

      let nform = {
        did: this.did,
        ip_adrs: this.filterDevice[0].ip_adrs.toLowerCase(),
      };

      this.$store
        .dispatch("exec_cnc_checkout", nform)
        .then((res) => {
          // console.log(res);
          if (res == "done") {
            this.snackbar = true;
            this.text = "更新成功";
            this.showloading = false;
          } else {
            this.snackbar = true;
            this.text = "更新失敗";
            this.showloading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clickbar(data) {
      // console.log("data:", data);
      this.dialog = true;
      // console.log("dialog:", this.dialog);
      //this.$router.push("/ReportCNC1");

      this.cutter_no = data.value;
      this.selectdidListValue = data.did;
    },
    init() {
      let that = this;
      let nform = {
        cust_id: this.loginInfo.cust_id,
      };

      this.fieldList = [];
      this.$store
        .dispatch("exec_cust_gateway_000", nform)
        .then((resall) => {
          if (this.loginUID.superuser == "0") {
            nform = {
              cust_id: this.loginInfo.cust_id,
              uid: this.loginInfo.uid,
            };

            this.$store
              .dispatch("exec_uid_gateway_000", nform)
              .then((res) => {
                if (resall != null && resall.length > 0) {
                  for (var j = 0; j < resall.length; j++) {
                    let ip_adrs = resall[j].ip_adrs.toLowerCase();

                    if (res != null && res.length > 0) {
                      for (var i = 0; i < res.length; i++) {
                        let gw_no = res[i].gw_no.toLowerCase();

                        // console.log(gw_no, ip_adrs);
                        if (ip_adrs == gw_no) {
                          this.fieldList.push(resall[j].gw_desc);
                        }
                      }

                      if (this.fieldList != null && this.fieldList.length > 0) {
                        if (
                          this.fieldListValue == null ||
                          this.fieldListValue == ""
                        ) {
                          this.fieldListValue = this.fieldList[0];
                        } else {
                        }
                      }
                    }
                  }
                  this.fieldChange(this.fieldListValue);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.fieldList = this.exec_cust_gateway_000.map(function (item) {
              return item.gw_desc;
            });

            if (this.fieldList != null && this.fieldList.length > 0) {
              if (this.fieldListValue == null || this.fieldListValue == "") {
                this.fieldListValue = this.fieldList[0];
              } else {
              }
            }

            this.fieldChange(this.fieldListValue);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    fieldChange(val) {
      //  this.fieldListValue = "d4:5d:64:41:71:2a";
      this.kpidataarray = [];
      this.filterDevice = this.exec_cust_gateway_000.filter(function (
        item,
        index,
        array
      ) {
        return item.gw_desc == val;
      });
      this.fieldListValue = val;

      //console.log(this.filterDevice[0].ip_adrs.toLowerCase())
      let nform = {
        ip_adrs: this.filterDevice[0].ip_adrs.toLowerCase(),
      };

      this.sensorData = [];

      this.didListValue = "ALL";

      nform = {
        cond: this.filterDevice[0].ip_adrs,
      };

      this.$store
        .dispatch("exec_equip_valname_000", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            this.didList = res.map(function (item) {
              return item.did;
            });
            this.didList = this.didList.filter(this.onlyUnique);
            this.didList.unshift("ALL");
            this.filterdid();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterdid() {
      let nform = {
        ip_adrs: this.filterDevice[0].ip_adrs,
      };

      this.$store
        .dispatch("exec_cutter_speed", nform)
        .then((res) => {
          let didlist = [];
          let didobjlist = [];
          if (res != null && res.length > 0) {
            for (var i = 0; i < this.didList.length; i++) {
              // console.log(this.didListValue, this.didList[i]);
              if (this.didListValue == "ALL") {
                if (this.didList[i] != "ALL") {
                  didlist.push(this.didList[i]);
                }
              } else if (this.didListValue.trim() == this.didList[i]) {
                didlist.push(this.didList[i]);
              }
            }

            didlist = didlist.filter(this.onlyUnique);
            if (didlist != null && didlist.length > 0) {
              for (var i = 0; i < didlist.length; i++) {
                let obj = {
                  did: didlist[i],
                  workarr: [],
                  speedarr: [],
                  CycleTime: 0,
                  MachineStatus: "",
                  statuscolor: "red",
                  wkno: "",
                };

                // console.log(obj)
                if (obj.did == this.did) {
                  didobjlist.push(obj);
                }
              }
            }
            for (var i = 0; i < res.length; i++) {
              for (var x = 0; x < didobjlist.length; x++) {
                if (didobjlist[x].did == res[i].did) {
                  let obj = {
                    dat: res[i].dat,
                    speed: res[i].speed,
                  };
                  didobjlist[x].speedarr.push(obj);
                }
              }
            }
            for (var x = 0; x < didobjlist.length; x++) {
              didobjlist[x].speedarr.sort(function (a, b) {
                return a.dat - b.dat;
              });
            }

            this.chartAjax(this.filterDevice[0].ip_adrs, didobjlist);
          } else {
            if (this.didList != null && this.didList.length > 0) {
              for (var i = 0; i < this.didList.length; i++) {
                //  console.log("this.didList[i]", this.didList[i]);
                if (this.didList[i] != "ALL") {
                  let obj = {
                    did: this.didList[i],
                    workarr: [],
                    speedarr: [],
                    CycleTime: 0,
                    MachineStatus: "",
                    statuscolor: "red",
                    wkno: "",
                  };
                  if (obj.did == this.did) {
                    didobjlist.push(obj);
                  }
                }
              }
            }

            //console.log("didobjlist", this.didList);
            this.chartAjax(this.filterDevice[0].ip_adrs, didobjlist);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    didChange(val) {
      let vall = val + "";
      if (val == "ALL") {
        vall = "ALL";
      }

      this.didListValue = vall;
      this.sensorData = [];
      this.filterdid();
    },
    chartAjax(val, didlist) {
      let nform = {
        ip_adrs: val,
      };
      this.$store
        .dispatch("exec_cnc_machine_status", nform)
        .then((res1) => {
          if (res1 != null && res1 != "not found" && res1.length >= 0) {
            for (var j = 0; j < res1.length; j++) {
              for (var x = 0; x < didlist.length; x++) {
                if (didlist[x].did == res1[j].did) {
                  if (res1[j].hasOwnProperty("tag_name")) {
                    if (res1[j].tag_name == "MachineStatus") {
                      didlist[x].MachineStatus = res1[j].tag_value;
                      if (res1[j].tag_value == "Disconnect") {
                        didlist[x].statuscolor = "redtext";
                      } else {
                        didlist[x].statuscolor = "greentext";
                      }
                    } else if (res1[j].tag_name == "CycleTime") {
                      didlist[x].CycleTime = res1[j].tag_value;
                      didlist[x].wkno = res1[j].wkno;
                    }
                  } else {
                    // console.log(res1[j])
                    didlist[x].workarr.push(res1[j]);
                  }
                }
              }
            }
          }

          for (var x = 0; x < didlist.length; x++) {
            didlist[x].workarr.sort(function (a, b) {
              return a.cutter_no - b.cutter_no;
            });
          }

          //  console.log(didlist);

          if (didlist != null) {
            for (var x = 0; x < didlist.length; x++) {
              let linechart = {
                labels: [],
                datasets: [],
              };

              let barchart = {
                labels: [],
                datasets: [],
              };

              if (didlist[x] != null && didlist[x].speedarr.length >= 10) {
                let lastthree = didlist[x].speedarr.length - 10;
                let label = [];
                let value = [];
                for (var j = lastthree; j < didlist[x].speedarr.length; j++) {
                  if (didlist[x].speedarr[j].dat != null) {
                    let datearr = didlist[x].speedarr[j].dat.split(" ");
                    label.push(datearr[1]);
                    value.push(didlist[x].speedarr[j].speed);
                  }
                }

                linechart = {
                  labels: label,
                  datasets: [
                    {
                      label: "Data One",
                      borderColor: "#FC2525",
                      pointBackgroundColor: "white",
                      borderWidth: 1,
                      pointBorderColor: "white",
                      data: value,
                    },
                  ],
                };
              } else if (
                didlist[x].speedarr != null &&
                didlist[x].speedarr.length >= 3
              ) {
                let lastthree = [x].speedarr.length - 3;
                let label = [];
                let value = [];
                for (var j = lastthree; j < didlist[x].speedarr.length; j++) {
                  let datearr = didlist[x].speedarr[j].dat.split(" ");
                  label.push(datearr[1]);
                  value.push(didlist[x].speedarr[j].value);
                }

                linechart = {
                  labels: label,
                  datasets: [
                    {
                      label: "Data One",
                      borderColor: "#FC2525",
                      pointBackgroundColor: "white",
                      borderWidth: 1,
                      pointBorderColor: "white",
                      data: value,
                    },
                  ],
                };
              }

              if (didlist[x] != null && didlist[x].workarr.length >= 0) {
                let label = [];
                let value = [];
                for (var j = 0; j < didlist[x].workarr.length; j++) {
                  let datearr = didlist[x].workarr[j].cutter_no;
                  label.push(datearr);
                  value.push(didlist[x].workarr[j].work_mins);
                }

                barchart = {
                  labels: label,
                  datasets: [
                    {
                      label: "Data One",
                      borderColor: "#FC2525",
                      pointBackgroundColor: "white",
                      borderWidth: 1,
                      pointBorderColor: "white",
                      data: value,
                    },
                  ],
                };
              }

              let obj = {
                did: didlist[x].did,
                CycleTime: didlist[x].CycleTime,
                MachineStatus: didlist[x].MachineStatus,
                wkno: didlist[x].wkno,
                key: didlist[x].did,
                statuscolor: didlist[x].statuscolor,
                linechart: linechart,
                barchart: barchart,
              };

              // console.log(barchart);
              this.sensorData.push(obj);
            }
          }

          this.sensorData.sort(this.compare);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    compare(a, b) {
      if (a.text < b.text) {
        return -1;
      }
      if (a.text > b.text) {
        return 1;
      }
      return 0;
    },
    nameChange1(val) {
      this.query_table_v2_cg_cutter_reason_desc(val)
        .then((res) => {
          //  console.log(res);
          if (res != null) {
            this.reasonDescList1 = [];
            for (var i = 0; i < res.length; i++) {
              let desc = res[i].reason_desc;
              // console.log(desc);
              this.reasonDescList1.push(desc);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    nameChange2(val) {
      this.query_table_v2_cg_cutter_reason_desc(val)
        .then((res) => {
          //  console.log(res);
          if (res != null) {
            this.reasonDescList2 = [];
            for (var i = 0; i < res.length; i++) {
              let desc = res[i].reason_desc;
              // console.log(desc);
              this.reasonDescList2.push(desc);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    nameChange3(val) {
      this.query_table_v2_cg_cutter_reason_desc(val)
        .then((res) => {
          //  console.log(res);
          if (res != null) {
            this.reasonDescList3 = [];
            for (var i = 0; i < res.length; i++) {
              let desc = res[i].reason_desc;
              // console.log(desc);
              this.reasonDescList3.push(desc);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    nameChange4(val) {
      this.query_table_v2_cg_cutter_reason_desc(val)
        .then((res) => {
          //  console.log(res);
          if (res != null) {
            this.reasonDescList4 = [];
            for (var i = 0; i < res.length; i++) {
              let desc = res[i].reason_desc;
              // console.log(desc);
              this.reasonDescList4.push(desc);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    ch_cutter() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        let par = encodeURIComponent(JSON.stringify(this.reasonObj));
        //console.log(par);

        let nform = this.reasonObj;
        let val = this.fieldListValue;
        this.filterDevice = this.exec_cust_gateway_000.filter(function (
          item,
          index,
          array
        ) {
          // console.log(item);
          return item.gw_desc == val;
        });
        // this.fieldListValue = val;

        // console.log(this.filterDevice[0].ip_adrs.toLowerCase());
        // let nform = {
        //   ip_adrs: this.filterDevice[0].ip_adrs.toLowerCase(),
        // };

        nform.cg_date = this.updatetime = moment().format(
          "YYYY/MM/DD HH:mm:ss"
        );
        nform.ip_adrs = this.filterDevice[0].ip_adrs.toLowerCase();
        nform.did = this.selectdidListValue;
        nform.cutter_no = this.cutter_no;

        this.$store
          .dispatch("do_change_cutter", nform)
          .then((res) => {
            // console.log(res);
            if (res == "done") {
              this.snackbar = true;
              this.text = "更新成功";
              this.showloading = false;
            } else {
              this.snackbar = true;
              this.text = "更新失敗";
              this.showloading = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    query_table_v2_cg_cutter_reason_desc(val) {
      return new Promise((response, reject) => {
        let nform = "reason_name= '" + val + "'";
        this.$store
          .dispatch("query_table_v2_cg_cutter_reason_desc", nform)
          .then((res) => {
            // console.log(res);
            response(res);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
  },
};
</script>

<style>
.font20 {
  font-size: 30px !important;
}

.chart {
  width: 100% !important;
  margin-right: 10px;
  float: left;
  height: 100% !important;
  max-height: 200px !important;
}

.redtext {
  color: red;
}

.greentext {
  color: green;
}

.inner-text {
  width: 100%;
  height: 100%;
}

.inner-text--3 {
  display: flex;
  justify-content: center;
  margin-top: 85px;
  font-size: 20px;
  color: #de3a21;
  font-weight: 700;
}
</style>